import script from "./PageToolbarFilterDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageToolbarFilterDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./PageToolbarFilterDropdown.vue?vue&type=style&index=0&id=28887596&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28887596"]])

export default __exports__